import { PublicKey } from "@solana/web3.js";
import { deserializeUnchecked, serialize } from "borsh";
import { Community } from "./community";
import { HapiAccountType } from "./enums";
class ReporterState {
    constructor(object) {
        Object.assign(this, object);
    }
}
ReporterState.schema = new Map([
    [
        ReporterState,
        {
            kind: "struct",
            fields: [
                ["account_type", "u8"],
                ["reporter_type", "u8"],
                ["name", "string"],
            ],
        },
    ],
]);
ReporterState.size = 34;
export class Reporter {
    constructor(data) {
        /// HAPI account type
        this.accountType = HapiAccountType.Reporter;
        if (data) {
            Object.assign(this, data);
        }
    }
    static async getAddress(programId, communityAddress, reporterPubkey) {
        return PublicKey.findProgramAddress([
            Buffer.from("reporter"),
            communityAddress.toBuffer(),
            reporterPubkey.toBuffer(),
        ], programId);
    }
    static fromState(state) {
        return new Reporter({
            accountType: state.account_type,
            reporterType: state.reporter_type,
            name: state.name,
        });
    }
    static deserialize(buffer) {
        return Reporter.fromState(deserializeUnchecked(ReporterState.schema, ReporterState, buffer));
    }
    static async retrieve(programId, connection, communityName, reporterPubkey) {
        const [communityAddress] = await Community.getAddress(programId, communityName);
        const [reporterAddress] = await Reporter.getAddress(programId, communityAddress, reporterPubkey);
        const account = await connection.getAccountInfo(reporterAddress);
        if (!account) {
            throw new Error(`Reporter not found: "${reporterPubkey}" in community "${communityName}" (${communityAddress})`);
        }
        return {
            data: Reporter.deserialize(account.data),
            account: reporterAddress,
        };
    }
    serialize() {
        const buf = Buffer.alloc(ReporterState.size);
        buf.set(serialize(ReporterState.schema, this.toState()));
        return buf;
    }
    toState() {
        return new ReporterState({
            account_type: this.accountType,
            reporter_type: this.reporterType,
            name: this.name,
        });
    }
}
Reporter.size = ReporterState.size;
//# sourceMappingURL=reporter.js.map